import { atom, useRecoilState, useSetRecoilState } from 'recoil';

const failedLoginDialogOpenAtom = atom({
  default: false,
  key: 'failedLoginDialogOpenAtom',
});

export function useFailedLoginDialogOpenState() {
  return useRecoilState(failedLoginDialogOpenAtom);
}

export function useSetFailedLoginDialogOpen() {
  return useSetRecoilState(failedLoginDialogOpenAtom);
}
